var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.608,
    height: 32.607,
    viewBox: "0 0 32.608 32.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Accepted",
    d: "M184.276,166.779a16.309,16.309,0,1,0,11.333,15.533,16.486,16.486,0,0,0-11.333-15.533Zm-2.582,29.368a14.041,14.041,0,1,1,8.583-22.586,13.991,13.991,0,0,1,3.054,8.751,14.211,14.211,0,0,1-11.638,13.835Zm5.872-17.695-1.523,1.523-6.841,6.838-1.684,1.684a1.282,1.282,0,0,1-.441.29c-1.016.481-1.935-.773-2.586-1.423l-3.3-3.3c-.427-.426-1-.982-.725-1.657a1.35,1.35,0,0,1,2.312-.471l3.03,3.028.764.764,5.491-5.488,3.057-3.055c.676-.676,1.574-1.865,2.633-1.058a1.245,1.245,0,0,1,.148.134,1.163,1.163,0,0,1,.135.148c.584.765.084,1.49-.467,2.041Z",
    transform: "translate(-163.002 -165.995)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/Accepted.ced4e05cffac1346ae01885a4133a9ee.svg";
export { ForwardRef as ReactComponent };